var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5 2.996a2 2 0 0 0-2 2l-.006 14.012a2 2 0 0 0 2 2h14a2 2 0 0 0 2-1.999L21 4.997a2 2 0 0 0-2-2.001zM19 5v4l-7.994-.004L11 4.998 9 5l-.017 3.996H5v-4zm-8 6 7.994.008v2.996L11 13.996zm-2.023 2.996L4.994 14v-2.996L8.977 11zM4.994 16l3.983-.004V19l-3.983.004zM11 19.004v-3.012l7.994.008v3.008z"
})));
export default SvgTable;